export default __webpack_public_path__ + "static/media/idea@4x.c0e8a641.svg";